import { useState, useEffect, useRef } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from "axios";
import ThemeMaker from "../../components/thememaker";
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import { config } from "../../utils/config";
import NewCategorylist from "../../components/CategoryTemplate/NewCategorylist";
import styles from "./Addcategory.module.css";
import { FaFolderPlus, FaEdit, FaTimes, FaLayerGroup } from "react-icons/fa";

const { apiEndpoint } = config;

const Addcategory = () => {
    const inputRef = useRef(null);
    const decoded = tokenDecode();
    const { data } = decoded || {};
    const [listing, setListing] = useState(false);
    let rawSubCatData = {
        parent_id: "",
        cat_name: "",
        status: true,
        id: ""
    };
    const [Subcategorydata, setSubcategorydata] = useState(rawSubCatData);
    const [isUpdate, setIsUpdate] = useState(false);
    const [taxData, setTaxData] = useState([]);
    const [selectsub, setSelectsub] = useState(0);
    const [tax, setTax] = useState({
        tax: '',
        status: true,
        id: ''
    });

    const taxD = {
        tax: false,
        name: false,
        parent_id: false
    };
    const [taxErrorData, setTaxErrorData] = useState(taxD);

    const errorHandler = (e) => {
        const { name, value } = e.target;
        if (name === "tax") {
            const val = typeof value === "string" ? value.trim() : "";
            if (!val) {
                setTaxErrorData((prev) => ({ ...prev, tax: true }));
            } else if (val.length > 20) {
                setTaxErrorData((prev) => ({ ...prev, tax: "max_length" }));
            } else if (!/^[a-zA-Z][a-zA-Z0-9\s]*$/.test(val)) {
                setTaxErrorData((prev) => ({ ...prev, tax: "invalid" }));
            } else {
                setTaxErrorData((prev) => ({ ...prev, tax: false }));
            }
        } else {
            if (value) {
                setTaxErrorData((prev) => ({ ...prev, [name]: false }));
            } else {
                setTaxErrorData((prev) => ({ ...prev, [name]: true }));
            }
        }
    };

    const createTaxHandler = async () => {
        try {
            const val = typeof tax.tax === "string" ? tax.tax.trim() : "";
            if (!val) {
                setTaxErrorData((prev) => ({ ...prev, tax: true }));
                toast.error("Please fill the required field !");
                return;
            }
            if (val.length > 20) {
                setTaxErrorData((prev) => ({ ...prev, tax: "max_length" }));
                toast.error("Category name cannot exceed 20 characters !");
                return;
            }
            if (!/^[a-zA-Z][a-zA-Z0-9\s]*$/.test(val)) {
                setTaxErrorData((prev) => ({ ...prev, tax: "invalid" }));
                toast.error("Category name must start with a letter and special characters are not allowed !");
                return;
            }

            setTaxErrorData((prev) => ({ ...prev, tax: false }));
            const { data } = await axios({
                url: `${apiEndpoint}/snp/categories/create`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    category_name: val,
                    status: tax.status === true || tax.status === "true"
                }
            });

            console.log("sdfghj46565767678", data)

            if (data?.status === true || data?.status === 200) {
                toast.success(data?.message);
                setTax({
                    tax: '',
                    status: true,
                    id: ''
                });
                setTaxErrorData({ tax: false, name: false, parent_id: false });
                taxListHanler();
            } else {
                toast.error(data?.message || "Error creating category!");
            }
        } catch (error) {
            console.log(error);
            const apiMsg = error?.response?.data?.message;
            toast.error(apiMsg || "Error creating category!");
        }
    };

    const taxListHanler = async () => {
        try {
            setListing(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/categories/get`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            if (data?.status === true || data?.status === 200 || data?.response) {
                const rawResponse = data.response || [];
                let parentCategories = [];

                if (Array.isArray(rawResponse)) {
                    for (let i = 0; i < rawResponse.length; i++) {
                        const item = rawResponse[i];
                        if (item && !Array.isArray(item) && typeof item === "object") {
                            const parentId = item.id;
                            let subArray = [];

                            if (i + 1 < rawResponse.length && Array.isArray(rawResponse[i + 1])) {
                                subArray = rawResponse[i + 1];
                            }

                            const mappedSubs = (subArray || []).map(sub => ({
                                ...sub,
                                cat_name: sub.cat_name || sub.name || "",
                                parent_id: sub.parent_id || parentId
                            }));

                            parentCategories.push({
                                ...item,
                                cat_name: item.cat_name || item.name || "",
                                subcategory: mappedSubs
                            });
                        }
                    }
                }

                if (parentCategories.length === 0) {
                    const flatCategories = Array.isArray(rawResponse) ? rawResponse.flat(Infinity) : [];
                    parentCategories = flatCategories
                        .filter(item => item.parent_id == 0 || item.parent_id == "0")
                        .map(parent => {
                            const subs = flatCategories
                                .filter(sub => sub.parent_id == parent.id)
                                .map(sub => ({
                                    ...sub,
                                    cat_name: sub.cat_name || sub.name
                                }));
                            return {
                                ...parent,
                                cat_name: parent.cat_name || parent.name,
                                subcategory: subs
                            };
                        });
                }

                setTaxData(parentCategories);
            }
            setListing(false);
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
            setListing(false);
        }
    };

    const editRedirect = async (id, parentCatName, isParentCategory) => {
        let endpointforCategoryView;
        if (isParentCategory) {
            endpointforCategoryView = `snp/categories/get/${id}`;
        } else {
            endpointforCategoryView = `snp/products/get-type/${id}`;
        }
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/${endpointforCategoryView}`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
            });

            if (data?.status === true || data?.status === 200 || data?.data) {
                const targetCat = (Array.isArray(data?.data) ? data.data[0] : data?.data) ||
                    (Array.isArray(data?.parent_id) ? data.parent_id[0] : data?.parent_id) ||
                    (Array.isArray(data?.response) ? data.response[0] : data?.response);

                if (targetCat) {
                    const catName = targetCat.name || targetCat.cat_name || targetCat.category_name || "";
                    const catStatus = targetCat.status !== undefined ? targetCat.status : true;
                    const catId = targetCat.id || id;
                    const parentId = targetCat.parent_id || 0;

                    setTax({
                        tax: catName,
                        status: catStatus,
                        id: catId
                    });
                    setSubcategorydata({
                        parent_id: parentId,
                        cat_name: catName,
                        status: catStatus,
                        id: catId
                    });
                    setSelectsub(parentId);
                }
            }
        } catch (error) {
            console.log("Error in editRedirect:", error);
        }
        setIsUpdate(true);
        setListing(false);
        setTaxErrorData(taxD);

        // Smooth scroll to top and focus Category Name input
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
                inputRef.current.focus();
            } else {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        }, 50);
    };

    const updateTax = async () => {
        try {
            const val = typeof tax.tax === "string" ? tax.tax.trim() : "";
            if (!val) {
                setTaxErrorData((prev) => ({ ...prev, tax: true }));
                toast.error("Please fill the required field !");
                return;
            }
            if (val.length > 20) {
                setTaxErrorData((prev) => ({ ...prev, tax: "max_length" }));
                toast.error("Category name cannot exceed 20 characters !");
                return;
            }
            if (!/^[a-zA-Z][a-zA-Z0-9\s]*$/.test(val)) {
                setTaxErrorData((prev) => ({ ...prev, tax: "invalid" }));
                toast.error("Category name must start with a letter and special characters are not allowed !");
                return;
            }

            setTaxErrorData((prev) => ({ ...prev, tax: false }));
            const targetId = tax.id;
            const { data } = await axios({
                url: `${apiEndpoint}/snp/categories/update/${targetId}`,
                method: "PUT",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    cat_name: val,
                    category_name: val,
                    name: val,
                    status: tax.status === true || tax.status === "true",
                    id: targetId
                }
            });

            if (data?.status === true || data?.status === 200 || data?.success) {
                toast.success(data?.message || "Category Updated !");
                taxListHanler();
                setIsUpdate(false);
                setTax({
                    tax: '',
                    status: true,
                    id: ''
                });
            } else {
                toast.error(data?.message || "Failed to update category!");
            }
        } catch (error) {
            console.log("updateTax error:", error);
            toast.error(error?.response?.data?.message || "Failed to update category!");
        }
    };

    const deleteTax = async (id) => {
        if (!window.confirm("Are you sure you want to delete this category?")) {
            return;
        }

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/categories/delete/${id}`,
                method: "DELETE",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            if (data?.status === true || data?.status === 200 || data?.success) {
                toast.success(data?.message || "Category Deleted !");
                taxListHanler();
            } else {
                toast.error(data?.message || "Error deleting category!");
            }
        } catch (error) {
            console.log(error);
            toast.error("Error deleting category!");
        }
    };

    const handleCancelEdit = () => {
        setIsUpdate(false);
        setTax({
            tax: '',
            status: true,
            id: ''
        });
        setTaxErrorData(taxD);
    };

    useEffect(() => {
        taxListHanler();
    }, []);

    return (
        <ThemeMaker>
            <div className={styles.pageContainer}>
                {/* Header Section */}
                <div className={styles.headerSection}>
                    <div>
                        <h1 className={styles.headerTitle}>
                            <FaLayerGroup style={{ color: "#f97316" }} />
                            Category Management
                        </h1>
                        <p className={styles.headerSubtitle}>
                            Create, configure, and organize store categories and subcategories.
                        </p>
                    </div>
                    <div className={styles.statsBadge}>
                        <span>Total Categories:</span>
                        <strong>{taxData?.length || 0}</strong>
                    </div>
                </div>

                {/* Form Card */}
                <div className={styles.formCard}>
                    <div className={styles.formCardHeader}>
                        <h2 className={styles.formCardTitle}>
                            {isUpdate ? (
                                <>
                                    <FaEdit style={{ color: "#f97316" }} />
                                    <span>Edit Category</span>
                                    <span className={styles.editingBadge}>ID: #{tax?.id}</span>
                                </>
                            ) : (
                                <>
                                    <FaFolderPlus style={{ color: "#f97316" }} />
                                    <span>Add New Category</span>
                                </>
                            )}
                        </h2>
                        {isUpdate && (
                            <button
                                type="button"
                                className={styles.cancelBtn}
                                onClick={handleCancelEdit}
                                style={{ height: "32px", padding: "0 12px", fontSize: "12px" }}
                            >
                                <FaTimes /> Cancel Edit
                            </button>
                        )}
                    </div>

                    <div className={styles.formCardBody}>
                        <div className={styles.formGrid}>
                            {/* Category Name Input */}
                            <div className={styles.formControlGroup}>
                                <div className={styles.labelRow}>
                                    <label className={styles.label}>
                                        Category Name <span className={styles.requiredStar}>*</span>
                                    </label>
                                    <span className={styles.charCount}>
                                        {(tax?.tax || "").length}/20
                                    </span>
                                </div>
                                <input
                                    ref={inputRef}
                                    type="text"
                                    className={`${styles.customInput} ${taxErrorData?.tax ? styles.inputError : ""}`}
                                    name="tax"
                                    placeholder="Enter Category Name (e.g., Electronics)"
                                    maxLength={20}
                                    value={tax.tax}
                                    onChange={(e) => {
                                        setTax({ ...tax, [e.target.name]: e.target.value });
                                        if (taxErrorData.tax) {
                                            errorHandler(e);
                                        }
                                    }}
                                    onBlur={(e) => errorHandler(e)}
                                />
                                {taxErrorData?.tax === true && (
                                    <div className={styles.errorMessage}>
                                        <span>•</span> This field is required !
                                    </div>
                                )}
                                {taxErrorData?.tax === "invalid" && (
                                    <div className={styles.errorMessage}>
                                        <span>•</span> Category name must start with a letter and special characters are not allowed !
                                    </div>
                                )}
                                {taxErrorData?.tax === "max_length" && (
                                    <div className={styles.errorMessage}>
                                        <span>•</span> Category name cannot exceed 20 characters !
                                    </div>
                                )}
                            </div>

                            {/* Status Selector */}
                            <div className={styles.formControlGroup}>
                                <div className={styles.labelRow}>
                                    <label className={styles.label}>Status</label>
                                </div>
                                <select
                                    value={String(tax.status)}
                                    name="status"
                                    className={styles.customSelect}
                                    onChange={(e) => setTax({ ...tax, [e.target.name]: e.target.value === "true" })}
                                >
                                    <option value="true">Active </option>
                                    <option value="false">Inactive </option>
                                </select>
                            </div>

                            {/* Action Buttons */}
                            <div className={styles.actionGroup}>
                                {!isUpdate && !listing ? (
                                    <button
                                        type="button"
                                        className={styles.primaryBtn}
                                        onClick={createTaxHandler}
                                    >
                                        <FaFolderPlus /> Save Category
                                    </button>
                                ) : (
                                    <>
                                        <button
                                            type="button"
                                            className={styles.updateBtn}
                                            onClick={updateTax}
                                        >
                                            <FaEdit /> Update Category
                                        </button>
                                        <button
                                            type="button"
                                            className={styles.cancelBtn}
                                            onClick={handleCancelEdit}
                                        >
                                            <FaTimes /> Cancel
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Categories Table / List Section */}
                <div className={styles.listCard}>
                    <NewCategorylist
                        item={taxData}
                        editRedirect={editRedirect}
                        deleteTax={deleteTax}
                    />
                </div>
            </div>
        </ThemeMaker>
    );
};

export default Addcategory;
